import { render, staticRenderFns } from "./CustomersHeader.vue?vue&type=template&id=4fa7bed2&"
import script from "./CustomersHeader.vue?vue&type=script&lang=js&"
export * from "./CustomersHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports